import { useMemo } from "react";
import { useSelector } from "react-redux";

import {
  ADMIN_PERMISSIONS,
  canAccessAdminNav,
  getStoredAdminPermissions,
  hasAdminPermission,
} from "./adminPermissions";
import { decryptPayload } from "./utils";
import { ROLES } from "./constants";
import { storedRoleList } from "../admin/countyRecorderAccess";

export const useAdminPermissions = () => {
  const { userProfileDetails } = useSelector((state) => state.userProfile);

  const permissions = useMemo(() => {
    const fromProfile = userProfileDetails?.data?.admin_permissions;
    if (Array.isArray(fromProfile) && fromProfile.length) {
      return fromProfile;
    }
    return getStoredAdminPermissions();
  }, [userProfileDetails]);

  const roles = storedRoleList(decryptPayload(localStorage.getItem("roles")));

  const isSuperAdmin = roles.includes(ROLES.admin);
  const isFullAdmin =
    isSuperAdmin || roles.includes(ROLES.subAdmin);
  const isMarketingAdmin = roles.includes(ROLES.marketingAdmin);
  const isBasicAccess = roles.includes(ROLES.basicAccess);

  return {
    permissions,
    isSuperAdmin,
    isFullAdmin,
    isMarketingAdmin,
    isBasicAccess,
    can: (permission) =>
      isFullAdmin || hasAdminPermission(permission, permissions),
    canNav: (navKey) =>
      isFullAdmin || canAccessAdminNav(navKey, permissions),
    ADMIN_PERMISSIONS,
  };
};

export default useAdminPermissions;
